module.exports = __webpack_public_path__ + "static/media/orionxblue.0901b867.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Home/Layout/Nav/Logo/orionxblue.svg
// module id = 1648
// module chunks = 85